import {IInsuranceFamily} from "@/model/InsuranceFamily/InsuranceFamily"

export interface IHasInsuranceFamiliesSelected {
    getInsuranceFamiliesSelected(): IInsuranceFamily[]
    getInsuranceFamiliesMapSelected(): Map<string, IInsuranceFamily>
    addInsuranceFamilySelected(insuranceFamily: IInsuranceFamily): void
    removeInsuranceFamilySelected(insuranceFamily: IInsuranceFamily): void
}


function hasInsuranceFamilies<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasInsuranceFamiliesSelected {
        private insuranceFamiliesSelected: IInsuranceFamily[] = []
        private insuranceFamiliesSelectedMap: Map<string, IInsuranceFamily> = new Map()
        
        constructor(...args: any[]) {
            super(...args);
        }

        public getInsuranceFamiliesSelected(): IInsuranceFamily[] {
            return this.insuranceFamiliesSelected
        }
        public getInsuranceFamiliesMapSelected(): Map<string, IInsuranceFamily> {
            return this.insuranceFamiliesSelectedMap
        }
        public addInsuranceFamilySelected(insuranceFamily: IInsuranceFamily): void {
            if (this.insuranceFamiliesSelectedMap.has(insuranceFamily.getId())) return
            this.insuranceFamiliesSelected.push(insuranceFamily)
            this.insuranceFamiliesSelectedMap.set(insuranceFamily.getId(), insuranceFamily)
        }
        public removeInsuranceFamilySelected(insuranceFamily: IInsuranceFamily): void {
            if (!this.insuranceFamiliesSelectedMap.has(insuranceFamily.getId())) return
            this.insuranceFamiliesSelected = this.insuranceFamiliesSelected.filter((existingInsuranceFamily: IInsuranceFamily) => existingInsuranceFamily.getId() !== insuranceFamily.getId())
            this.insuranceFamiliesSelectedMap.delete(insuranceFamily.getId())
        }

    };
}

export default hasInsuranceFamilies